// eslint-disable-next-line no-unused-vars
import React from 'react';
import Container from './Container';
import withContainer from "./withContainer";
import withModule from '../../withModule';

/*import DashboardBroker from "./broker/Dashboard"
import NetworkPage from "./broker/NetworkPage"
import ReportBroker from "./broker/SalesReportPage"
import SalesBroker from "./broker/SalesPage"
import BrokerSalesHistoryPage from "./broker/BrokerSalesHistoryPage"
import OrderDetailPage from "./broker/OrderDetailPage"
import CustomerListPage from "./broker/CustomerListPage"
import CustomerCarePage from "./broker/CustomerCarePage"
import CustomerFunnelPage from "./broker/CustomerFunnelPage";
import ReferralPage from "./broker/ReferralPage";
import MyProductsPage from "./broker/MyProductsPage";*/

import Home from "./Home";
const routes=[
    {
        id:'home',
        path: "/",
        component: Home,
        exact:true
    },
    {
        id:'dashboard',
        path: "/dashboard",
        component: Home,
        exact:true
    },
    {
        id:'DashboardBroker',
        path: "/broker",
        component: withModule('broker/Dashboard.jsx'),
        exact:true
    },
    {
        id:'SalesReportPage',
        path: "/ctv-report",
        component: withModule('broker/SalesReportPage.jsx'),
        isDialog:true,
        exact:true
    },
    {
        id:'BrokerSalesHistoryPage',
        path: "/ctv-sales-history",
        isDialog:true,
        component: withModule('broker/BrokerSalesHistoryPage.jsx'),
        exact:true
    },

    {
        id:'OrderDetailPage',
        path: "/ctv-sales-detail/:id",
        component: withModule('broker/OrderDetailPage.jsx'),
        isDialog:true,
        exact:true
    },
    {
        id:'MyProductsPage',
        path: "/my-products",
        component: withModule('broker/MyProductsPage.jsx'),
        isDialog:true,
        exact:true
    },
    {
        id:'SalesBroker',
        path: "/ctv-sales/:ma_dt",
        isDialog:true,
        component: withModule('broker/SalesPage.jsx'),
        exact:true
    },
    {
        id:'NetworkPage',
        path: "/ctv-network",
        isDialog:true,
        component: withModule('broker/NetworkPage.jsx'),
        exact:true
    },
    {
        id:'CustomerListPage',
        path: "/ctv-customer",
        isDialog:true,
        component: withModule('broker/CustomerListPage.jsx'),
        exact:true
    },
    {
        id:'customer-care',
        path: "/customer-care/:ma_kh",
        isDialog:true,
        component: withModule('broker/CustomerCarePage.jsx'),
        exact:true
    },
    {
        id:'CustomerFunnelPage',
        path: "/customer-funnel",
        isDialog:true,
        component: withModule('broker/CustomerFunnelPage.jsx'),
        exact:true
    },

    {
        id:'ReferralPage',
        path: "/referral",
        isDialog:true,
        component: withModule('broker/ReferralPage.jsx'),
        exact:true
    },
    {
        id:'profile',
        path: "/profile",
        component: withModule("Profile"),
        //isDialog:true,
        exact:true
    },
    {
        id:'cart',
        path: "/cart",
        isDialog:true,
        component: withModule("Cart"),
        exact:true
    },
    {
        id:'notifications',
        path: "/notifications",
        isDialog:true,
        component: withModule("Notifications"),
        exact:true
    },
    {
        id:'mine',
        path: "/mine",
        component: withModule("Mine"),
        exact:true
    },
    {
        id:'agent',
        path: "/daily",
        component: withModule('DashboardDaiLy'),
        exact:true
    },
    {
        id:'chat',
        path: "/chat",
        isDialog:true,
        component: withModule('Chat'),
    },

    {
        id:'frm',
        path: "/m/:module/frm/:id",
        component: withContainer(Container)(withModule('financial/FRMpage')),
    },
    {
        id:'frm',
        path: "/frm/:id",
        component: withContainer(Container)(withModule('financial/FRMpage')),
    },

    {
        id:'m-list',
        path: "/m/:module/list/:code",
        
        component:  withContainer(Container)(withModule("accounting/List")),
        exact:true
    },
    {
        id:'m-voucher',
        path: "/m/:module/voucher/:code",
        
        component: withContainer(Container)(withModule("accounting/Voucher")),
        exact:true
    },
    {
        id:'m-report',
        path: "/m/:module/report/:code",
        component: withContainer(Container)(withModule("accounting/Report")),
        exact:true
    },
    {
        id:'appInfo',
        path: "/m/:module/system/appinfo",
        component: withModule('AppInfo'),
    },
    
    {
        id:'timelinetask',
        path: "/m/:module/timeline-task",
        component: withModule('task/TimelineTask'),
    },
    {
        id:'timelinetask',
        path: "/timeline-task",
        component: withModule('task/TimelineTask'),
    },

    {
        id:'grantttask',
        path: "/m/:module/grantt-task",
        component: withModule('task/GranttTask'),
    },
    {
        id:'grantttask',
        path: "/grantt-task",
        component: withModule('task/GranttTask'),
    },

    {
        id:'grouptask',
        path: "/m/:module/group-task",
        component: withModule('task/GroupTask'),
    },
    {
        id:'grouptask',
        path: "/group-task",
        component: withModule('task/GroupTask'),
    },

    {
        id:'gridtask',
        path: "/m/:module/banlamviec",
        component: withModule('task/GridTask'),
    },
    {
        id:'gridtask',
        path: "/banlamviec",
        component: withModule('task/GridTask'),
    },

    {
        id:'viewtask',
        isDialog:true,
        path: "/task/:_id",
        component: withModule('task/ViewTask'),
    },
    {
        id:'dmbp',
        path: "/dmbp",
        
        component: withModule('hrm/dmbp'),
    },
    {
        id:'dmbp',
        path: "/m/:module/dmbp",
        
        component: withModule('hrm/dmbp'),
    },
    {
        id:'lenhsxview',
        path: "/m/:module/voucher/lenhsx/:_id",
        component: withModule('accounting/views/LenhsxView'),
    },
    {
        id:'congdoanview',
        path: "/m/:module/list/congdoansx/:_id",
        component: withModule('accounting/views/CongdoanView'),
    },
    {
        id:'productuser',
        path: "/pu/:app_code/:so_seri",
        component: withModule('ProductUser'),
    },
    {
        id:'search',
        path: "/search/:search_text",
        
        component: withModule('Search'),
        exact:true
    },
    {
        id:'module',
        path: "/m/:module",
        
        component: withModule('Module'),
        exact:true
    },
    {
        id:'t',
        path: "/t/:code",
        component: withModule('T'),
    },
    {
        id:'list',
        path: "/list/:code",
        
        component: withContainer(Container)(withModule("accounting/List")),
    },
    
    {
        id:'view',
        isDialog:true,
        path: "/view/:code/:_id",
        component: withModule('View'),
    },
    {
        id:'voucher',
        path: "/voucher/:code",
        
        component: withContainer(Container)(withModule("accounting/Voucher")),
    },

    {
        id:'quicklist',
        path: "/quicklist/:code",
        
        component: withContainer(Container)(withModule("accounting/List")),
    },
    {
        id:'quickinput',
        isDialog:true,
        path: "/quickinput/:code",
        component: withContainer(Container)(withModule("accounting/QuickInput")),
    },
    {
        id:'report',
        path: "/report/:code",
        
        component: withContainer(Container)(withModule("accounting/Report")),
    },
   

    {
        id:'Flow',
        path: "/m/:module/floweditor/:flow_id",
        component: withModule('Flow'),
    },

    {
        id:'Flow',
        path: "/floweditor/:flow_id",
        component: withModule('Flow'),
    },

    {
        id:'ProductManagement',
        path: "/ProductManagement",
        
        component: withModule('sys/ProductManagement'),
    },
    {
        id:'ProductManagement',
        path: "/m/:module/ProductManagement",
        
        component: withModule('sys/ProductManagement'),
    },

    
    {
        id:'filemanagement',
        path: "/filemanagement",
        
        component: withModule('sys/FileManagement'),
    },
    {
        id:'filemanagement',
        path: "/m/:module/filemanagement",
        
        component: withModule('sys/FileManagement'),
    },

    {
        id:'DiscountManagement',
        path: "/discountmanagement",
        
        component: withModule('sys/DiscountManagement'),
    },
    {
        id:'DiscountManagement',
        path: "/m/:module/discountmanagement",
        
        component: withModule('sys/DiscountManagement'),
    },

    {
        id:'CustomerManagement',
        path: "/customermanagement",
        
        component: withModule('sys/CustomerManagement'),
    },
    {
        id:'CustomerManagement',
        path: "/m/:module/customermanagement",
        
        component: withModule('sys/CustomerManagement'),
    },

    {
        id:'BdsManagement',
        path: "/bdsmanagement",
        
        component: withModule('sys/BdsManagement'),
    },
    {
        id:'BdsManagement',
        path: "/m/:module/bdsmanagement",
        
        component: withModule('sys/BdsManagement'),
    },

    
    {
        id:'usergroup',
        path: "/usergroup",
        
        component: withModule('sys/UserManagement'),
    },
    {
        id:'usergroup',
        path: "/m/:module/usergroup",
        
        component: withModule('sys/UserManagement'),
    },
    

    {
        id:'appInfo',
        path: "/system/appinfo",
        component: withModule('AppInfo'),
    },
    
    
    //okr
    {
        id:'okr',
        path: "/okr/:_id",
        component: withModule('okr/OkrView'),
    },
    {
        id:'keyresultview',
        path: "/keyresult/:_id",
        component: withModule('okr/KeyresultView'),
    },
    //experience journey
    {
        id:'experiencejourneyView',
        path: "/experience-journey/data/:idJourney",
        component: withModule('experiencejourney/DataPage'),
    },
    {
        id:'experiencejourneySetup',
        path: "/experience-journey/setup/:idJourney",
        component: withModule('experiencejourney/SetupPage'),
    },
    //strategic
    {
        id:'strategicdiagram',
        path: "/strategicdiagram/:id_link",
        component: withModule('strategic/StrategicDiagram'),
    },
    {
        id:'strategicplan',
        path: "/strategicplan/:_id",
        component: withModule('strategic/StrategicPlanView'),
    },
    {
        id:'strategicgoal',
        path: "/strategicgoal/:_id",
        component: withModule('strategic/StrategicGoalView'),
    },
    {
        id:'strategicobjective',
        path: "/strategicobjective/:_id",
        component: withModule('strategic/StrategicObjectiveView'),
    },
    {
        id:'strategickpi',
        path: "/strategickpi/:_id",
        component: withModule('strategic/StrategickpiView'),
    },
    {
        id:'bmc',
        path: "/bmc/:_id",
        component: withModule('bmc/Bmc'),
    },
    //
    {
        id:'404',
        path: "/404",
        component: withModule('NotFound'),
        exact: true,
    }

]
export default routes;
